import { render, staticRenderFns } from "./AppNavbarHorizontalLayout.vue?vue&type=template&id=489e4685&scoped=true&"
import script from "./AppNavbarHorizontalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarHorizontalLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarHorizontalLayout.vue?vue&type=style&index=0&id=489e4685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e4685",
  null
  
)

export default component.exports